module.exports = __webpack_public_path__ + "static/media/alliance.4fba47a0.jpg";